import React, { Component } from 'react';
import PropTypes from 'prop-types';
import parseUrl from 'video-service-url-parser';
import { SOURCE_YOUTUBE } from './Constants';

function noop() {}

function initYouTubeSDK() {
    if (window.YT) return Promise.resolve(window.YT);
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.type = 'text/javascript';
        script.onerror = (error) => {
            reject(error);
        };
        script.onload = () => {
            window.YT.ready(() => {
                resolve(window.YT);
            });
        };
        document.head.appendChild(script);
    });
}

export default class YouTubePlayer extends Component {
    static propTypes = {
        dimensions: PropTypes.shape({
            h: PropTypes.number.isRequired,
            w: PropTypes.number.isRequired,
        }).isRequired,
        onEnd: PropTypes.func.isRequired,
        onPause: PropTypes.func.isRequired,
        onPlay: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired,
    };

    static defaultProps = {
        autoplay: false,
        onPlay: noop,
        onPause: noop,
        onEnd: noop,
    };

    componentDidMount() {
        const playerConfig = {
            height: this.props.dimensions.h,
            width: this.props.dimensions.w,
            videoId: parseUrl(this.props.url).videoId,
            playerVars: {
                autoplay: 0,
                rel: 0,
                controls: 1,
            },
        };

        initYouTubeSDK()
            .then((YT) => {
                this.internalPlayer = new YT.Player(
                    this.refs.videoContainer,
                    playerConfig
                );
                this._bindEvents();
            })
            .catch(console.error.bind(console));
    }

    componentWillUnmount() {
        if (this.internalPlayer) {
            this.removeListener();
        }
    }

    _bindEvents() {
        this.internalPlayer.addEventListener(
            'onStateChange',
            this._handlePlayerStateChange
        );
        this.internalPlayer.addEventListener(
            'onReady',
            this._handlePlayerReady
        );
    }

    _handlePlayerStateChange = (event) => {
        switch (event.data) {
            case window.YT.PlayerState.ENDED:
                this.props.onEnd(SOURCE_YOUTUBE);
                break;

            case window.YT.PlayerState.PLAYING:
                this.props.onPlay(SOURCE_YOUTUBE);
                break;

            case window.YT.PlayerState.PAUSED:
                this.props.onPause(SOURCE_YOUTUBE);
                break;

            default:
                return;
        }
    };

    _handlePlayerReady = (event) => {
        event.target.playVideo();
    };

    removeListener() {
        this.internalPlayer.removeEventListener(
            'onStateChange',
            this._handlePlayerStateChange
        );
        this.internalPlayer.removeEventListener(
            'onReady',
            this._handlePlayerReady
        );
    }

    render() {
        return (
            <div className="video-container image-frame">
                <div ref="videoContainer" />
            </div>
        );
    }
}
